// System
import { Button } from '@mui/material';
// Components
import FormProvider from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { UpdateProviderConfigContent } from './UpdateProviderConfigContent';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
// Form
import { useUpdateProviderConfigForm } from '@Forms/providers/UpdateProviderConfigFormContext';
// Redux
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useUpdateProviderConfig } from '@Modal/hooks/providers/useUpdateProviderConfig';

export const UpdateProviderConfigForm = () => {
  const methods = useUpdateProviderConfigForm();
  const { userPermissions } = useAuthorization();
  const canManageProviderConfigs = userPermissions?.includes('CAN_MANAGE_PROVIDER_CONFIGS');
  const { handleUpdateCancel, handleSubmitUpdateProviderConfig } = useUpdateProviderConfig();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <UpdateProviderConfigContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleUpdateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!canManageProviderConfigs}
              onClick={handleSubmitUpdateProviderConfig}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
